import { useQuery } from 'src/shared/lib/useQuery';
import { genQueryKey } from 'src/shared/lib/query.utils';
import { QueryResult } from 'src/shared/types/util.types';
import { useOrg } from 'src/shared/contexts/OrgContext';
import { ExtractionModelListItem } from 'src/shared/types/extraction-model.types';

export function useExtractionModels(): QueryResult<ExtractionModelListItem[]> {
  const { orgFetch, currentOrg } = useOrg();

  const queryKey = ['next-gen', 'models', 'extraction', genQueryKey(currentOrg.id)];

  return useQuery({
    queryFn: getData,
    queryKey: queryKey,
    staleTime: 0,
  });

  async function getData() {
    const res = await orgFetch<ExtractionModelListItem[]>(`/api/v2/next-gen-models/extraction`);
    if (!res.ok) {
      throw new Error('Failed to fetch extraction models');
    }
    const models = await res.json();

    return models;
  }
}
